import { z } from 'zod';
import { BRAND_NAME_MAX_LENGTH } from './constants.js';
import { StudioRole } from './roles.js';
export const BrandAccess = z.object({
    brandId: z.string().uuid(),
    brandSlug: z.string(),
    brandName: z.string(),
    brandColour: z.string().nullable(),
    orgId: z.string().uuid(),
    orgSlug: z.string(),
    orgName: z.string(),
    role: StudioRole,
});
/** Whether the organisation may use the product: a trial runs to its end date; the operator sets active or lapsed. */
export const AccessState = z.enum(['trial', 'active', 'lapsed']);
export const OrgAccess = z.object({
    state: AccessState,
    trialEndsAt: z.string().nullable(),
});
export const ApprovalMode = z.enum(['client', 'self']);
export const DailyShape = z.object({ trending: z.number().int().min(0).max(10), original: z.number().int().min(0).max(10) });
export const BrandSettings = z.object({
    approvalMode: ApprovalMode,
    shareWithinOrg: z.boolean(),
    dailyShape: DailyShape,
    cooldownDays: z.number().int().min(0),
    cooldownPosts: z.number().int().min(0),
    timezone: z.string(),
});
export const BrandSettingsPatch = BrandSettings.partial();
export const TenantMe = z.object({
    accountId: z.string().uuid(),
    email: z.string(),
    displayName: z.string(),
    brands: z.array(BrandAccess),
    active: BrandAccess.nullable(),
    access: OrgAccess.nullable(),
    hasAccess: z.boolean(),
    settings: BrandSettings.nullable(),
});
export const BrandName = z.string().trim().min(1).max(BRAND_NAME_MAX_LENGTH);
/** What the Team panel may hand out. Owners are added by owners; a creator is always brand-scoped. */
export const InviteRole = StudioRole;
export const TeamMember = z.object({
    accountId: z.string().uuid().nullable(),
    inviteId: z.string().uuid().nullable(),
    email: z.string(),
    name: z.string(),
    role: StudioRole,
    brand: z.string().nullable(),
    pending: z.boolean(),
    since: z.string(),
});
export const QueueCounts = z.object({
    awaitingUpload: z.number().int(),
    awaitingSnippet: z.number().int(),
    confirming: z.number().int(),
    awaitingTagging: z.number().int(),
    awaitingApproval: z.number().int(),
    scheduled: z.number().int(),
});
//# sourceMappingURL=tenant.js.map